// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"1":"959f5f9c","48":"fc75aa55","72":"e9427ca3","353":"1955bcf7","501":"427b77f7","794":"97f9119d","852":"334af278","875":"ebe18c39"}[chunkId] + ".js";
};